/*
  EKS live search (search-as-you-type). v8.027: moved out of the section so the
  header search panel and the /search page share one copy.
  Enhances any input carrying [data-eks-live-search] (header panel) and the
  search page field (.eks-search__form input[name=q]). After 2+ characters it
  queries Shopify's predictive search API (/search/suggest.json) and shows
  Suggestions, Pages and up to 6 Products under the field. Fields searched
  include the product description, so FCC IDs and "Also Replaces Part #(s)"
  numbers match too. Up/Down to move, Enter to open, Esc to close.
*/
(function () {
  if (window.__eksLiveSearch) return;
  window.__eksLiveSearch = true;

  var FIELDS = 'title,product_type,variants.title,variants.sku,vendor,tag,body';
  var money = function (v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var highlight = function (title, q) {
    var safe = esc(title);
    q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      var re = new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      safe = safe.replace(re, '<mark>$1</mark>');
    });
    return safe;
  };
  var imgUrl = function (u) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  };

  function attach(input) {
    if (input.dataset.eksLsReady) return;
    input.dataset.eksLsReady = '1';
    var form = input.form;
    // Anchor the dropdown to the whole form so it spans the field + button.
    var wrap = input.form || input.parentElement;
    wrap.classList.add('eks-ls');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'eks-ls__panel';
    panel.hidden = true;
    panel.id = 'eks-ls-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-controls', panel.id);
    wrap.appendChild(panel);

    var timer, lastQ = '', active = -1, controller;

    function options() { return panel.querySelectorAll('[data-eks-ls-opt]'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    input.eksLsClose = close;
    function setActive(i) {
      var opts = options();
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    function searchUrl(q) { return (form ? form.action : '/search') + '?q=' + encodeURIComponent(q); }

    function render(q, r) {
      var products = r.products || [], queries = (r.queries || []).slice(0, 4), pages = (r.pages || []).slice(0, 3);
      if (!products.length && !pages.length) {
        panel.innerHTML = '<div class="eks-ls__empty">No keys match <b>' + esc(q) +
          '</b>. Try the FCC ID, part number, or search by vehicle.</div>';
        open();
        return;
      }
      var html = '<div class="eks-ls__scroll">';
      if (queries.length) {
        html += '<div class="eks-ls__h">Suggestions</div><ul class="eks-ls__list" role="listbox">';
        queries.forEach(function (s) {
          html += '<li class="eks-ls__q" role="option" data-eks-ls-opt aria-selected="false"><a href="' +
            esc(searchUrl(s.text)) + '">' + (s.styled_text || esc(s.text)) + '</a></li>';
        });
        html += '</ul>';
      }
      if (pages.length) {
        html += '<div class="eks-ls__h">Pages</div><ul class="eks-ls__list" role="listbox">';
        pages.forEach(function (p) {
          html += '<li class="eks-ls__q" role="option" data-eks-ls-opt aria-selected="false"><a href="' +
            esc(p.url) + '">' + highlight(p.title, q) + '</a></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<div class="eks-ls__h">Products</div><ul class="eks-ls__list" role="listbox">';
        products.forEach(function (p) {
          var cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
          html += '<li class="eks-ls__item" role="option" data-eks-ls-opt aria-selected="false">' +
            '<a href="' + esc(p.url) + '">' +
            (p.image ? '<img class="eks-ls__img" src="' + esc(imgUrl(p.image)) + '" alt="" loading="lazy" width="52" height="52">' : '<span class="eks-ls__img"></span>') +
            '<span class="eks-ls__text"><span class="eks-ls__title">' + highlight(p.title, q) + '</span>' +
            '<span class="eks-ls__price">' + money(p.price) + cmp + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      html += '</div><a class="eks-ls__all" data-eks-ls-opt href="' + esc(searchUrl(q)) + '">' +
        '<span>See all results for &ldquo;' + esc(q) + '&rdquo;</span><span>&rarr;</span></a>';
      panel.innerHTML = html;
      active = -1;
      open();
    }

    function search(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query,page&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=' + FIELDS;
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (input.value.trim() !== q) return;
          render(q, (j.resources && j.resources.results) || {});
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { lastQ = ''; close(); return; }
      if (q === lastQ) return;
      timer = setTimeout(function () { lastQ = q; search(q); }, 180);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) open();
    });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { e.stopPropagation(); close(); }
      else if (e.key === 'Enter' && active > -1) {
        var opt = options()[active];
        var link = opt.tagName === 'A' ? opt : opt.querySelector('a');
        if (link) { e.preventDefault(); window.location.href = link.href; }
      }
    });
    if (form) form.addEventListener('reset', function () { lastQ = ''; close(); });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('input[data-eks-live-search], .eks-search__form input[name="q"]').forEach(function (input) {
      attach(input);
      // On the /search page, put the cursor in the box (desktop only, so phones
      // don't pop the keyboard over the vehicle finder).
      if (!input.hasAttribute('data-eks-live-search') && !input.value && window.matchMedia('(hover: hover)').matches) input.focus();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
